import React from "react"
import { Avatar, Button } from "@mui/material"
import {
  ChevronDownIcon,
  UserCircleIcon,
  SignOutIcon,
  FaIcon
} from "../../../../../mp-core/icons"
import DropdownMenu from "../../../../generic-shared-components/components/DropdownMenu"
import { User } from "../../../../../mp-database"
import { useStyles } from "./styles"
import { useLogoutAction } from "./hooks"
import InitiatedFeedbackContainer from "../../../../../mp-core/components/FeedbackTray/InitiatedFeedbackContainer"

type Props = {
  user?: User
}

const ProfileDropDown: React.FC<React.PropsWithChildren<Props>> = ({
  user
}) => {
  const { classes } = useStyles()

  const { handleLogout } = useLogoutAction(user)

  return (
    <InitiatedFeedbackContainer user={user}>
      {(showFeedbackItem, openFeedbackTray) => (
        <DropdownMenu
          id="profile-dropdown"
          anchor={
            <Button
              disableRipple
              startIcon={
                <Avatar
                  // @ts-ignore profileImage doesnt exist yet
                  src={user?.profileImage}
                  className={classes.profileAvatar}
                  data-automation-id="profileAvatarIcon"
                >
                  {`${user?.firstName?.charAt(0) || ""}${
                    user?.lastName?.charAt(0) || ""
                  }`}
                </Avatar>
              }
              endIcon={
                <ChevronDownIcon
                  size="xsmall"
                  style={{
                    fontSize: "0.6875rem"
                  }}
                />
              }
              className={classes.iconDropDown}
              classes={{
                endIcon: classes.dropDownEndIcon
              }}
              aria-label="User Dropdown"
              data-automation-id="profile-dropdown"
            />
          }
          options={[
            {
              id: "profile",
              label: "Profile",
              href: "/profile",
              role: "listitem",
              "data-automation-id": "profile",
              icon: <UserCircleIcon />
            },
            ...(showFeedbackItem
              ? [
                  {
                    id: "feedback",
                    label: "Give Feedback",
                    role: "listitem",
                    "data-automation-id": "feedback",
                    icon: <FaIcon name="comment-lines" solid size="med" />,
                    action: openFeedbackTray
                  }
                ]
              : []),
            {
              id: "logout",
              label: "Logout",
              role: "listitem",
              "data-automation-id": "logout",
              icon: <SignOutIcon />,
              action: handleLogout
            }
          ]}
          disablePortal
          anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
          transformOrigin={{ horizontal: "right", vertical: "top" }}
          MenuListProps={{ role: "list" }}
          classes={{
            paper: classes.paper,
            menuList: classes.menuList,
            menuItem: classes.menuListItem
          }}
        />
      )}
    </InitiatedFeedbackContainer>
  )
}

export default ProfileDropDown
